import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import "./OnlineBanking.css"
import moneytransfer from "../../assets/images/transference.png"
import deposit from "../../assets/images/deposit.png"
import bank from "../../assets/images/secure-image.jpg"
import { Enroll_link } from '../../constants/links';




const EBillingPage = () => {
  return (
    <div>
      <SimpleHero
        title="Bank from anywhere, securely"
        subtitle="24/7 access to balances, transfers, bill pay, and e‑statements."
        primaryLabel="Enroll"
        primaryHref={Enroll_link}
        variant="sofi"
        imageSrc={bank}
        imageAlt="Online banking security"
        imageOn="right"
        tiltImage
        badges={["Secure access","Bill pay","e‑Statements"]}
      />

      {/* Features Section */}
      <section className="features-section py-5 bg-light">
        <Container>
          <h2 className="text-center mb-4 gn-secondary-title">Why Choose Online Banking?</h2>
          <Row>
            {[{title:'Secure access',image:bank},{title:'Bill pay',image:moneytransfer},{title:'e‑Statements',image:deposit},{title:'Mobile',image:bank}].map((feature, index) => (
              <Col md={6} lg={3} className="mb-4" key={index}>
                <Card className="h-100 shadow-sm">
                  <Card.Img variant="top" src={feature.image} alt={feature.title} className='py-1' />
                  <Card.Body>
                    <Card.Title>{feature.title}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Security Section */}
      <section className="security-section">
        <Container className='py-5'>
          <h3 className="text-center mb-4 h3 gn-title">Your Security -  Our Priority</h3>
          <div className='secure-body'>
          <Row className=''>
            <Col md={6}>
              <p className='py-5'>
                We use the latest encryption and authentication technologies to
                protect your information.
              </p>
              <ul className=''>
                <li>Two-factor authentication for added security.</li>
                <li>Real-time alerts for suspicious activity.</li>
                <li>SSL encryption for all online transactions.</li>
              </ul>
            </Col>
            <Col md={6}>
              <img
                src={bank} 
              
                alt="Security"
                className="img-fluid"
              />
            </Col>
          </Row>
          </div>
        </Container>
      </section>

      {/* Call-to-Action Section */}
      <section className="cta-section text-center text-white py-5">
        <Container>
          <h2>Ready to Bank Online?</h2>
          <p className="lead text-center text-white">
            Join thousands of satisfied customers and take control of your finances today.
          </p>
 <div className='gn-button-div'>
          <Button
            as="a"
            href={Enroll_link}
            target="_blank"
            rel="noopener noreferrer"
            size="lg"
            className='gn-button'
          >
            Enroll
          </Button>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default EBillingPage;
